import { Footer } from "../../Footer/Footer"
import { HerosectionsAll } from "../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../IndexPage/Header/Header"


export const Values = () => {
    return (
        <>
 <div className="container-fluid">
            <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header  actives="Values" subactive="Values"/>
                    <HerosectionsAll ScreenName="Values" ScreenSearch="Values" />

                    <div className="row p-2 px-lg-5 ">

                        <div className="col-12 col-lg-6 p-lg-5 d-flex p-4 justify-content-center align-items-center">
                            <div className="row px-lg-5 py-4 faint rounded value_height">
                                <div className="col-12">
                                    {/* <h2 className="fw-bold display-5 green">Vision</h2>
                                    <div className="col-8 col-lg-3 mb-2  zoom-in-out-box2 text-center">
                                        <hr />
                                    </div> */}
                                </div>
                                <div className="col-12">
                                    <p className="pt-lg-3" style={{ textAlign: 'justify', fontSize:'20px' }}>"MILSO believes in striving to achieve professional independence and inter-dependence with Clients for mutual benefit by promoting empowerment of individuals, teams and organizations for growth and prosperity. We will be driven by ethical considerations at all times, never compromising on our values". </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-lg-6 pb-4 pb-lg-0 px-lg-5 d-flex  justify-content-center align-items-center">
                            <img src="Static/Assets/Img/values.JPG" className="Marine_insurance_mission" alt="" />
                        </div>

                    </div>

                    <Footer />
                </div>
            </div>
</div>

        </>
    )
}
